import { call, put, takeEvery, delay } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

function* createOrgSaga({ payload }) {
    try {
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.CREATE_ORG,
            data: {
                ...payload,
                address_1: "",
                address_2: "",
                city: "",
                region: "",
                postal_code: "",
                country_code: 235,
                active: true,
                reseller: 1,
                // acts: [1,2,3,4,5],  // sending acts via payload
            }
        });
        if (apiResponse.res.data.response === 200) {
            yield put({
                type: ActionTypeConstants.CREATE_ORG_SUCCESS,
                payload: apiResponse.res.data.data
            });
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Organization created!",
                    color: "success"
                }
            });
            // yield put({
            //     type: ActionTypeConstants.LOAD_USER_ORG_SITE
            // });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "Creating organization failed!",
                    color: "danger"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "Creating organization failed!",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeEvery(ActionTypeConstants.CREATE_ORG, createOrgSaga);
}
